import { useMemo } from 'react';

import Summary from '../../../shared/summary';
import Table from '../../../shared/table';
import Bars from '../../../shared/bars';
import Diagram from '../../../shared/diagram';
import StackBars from '../../../shared/stack-bars';
import PieChart from '../../../shared/pie';

import { formatToCurrency, formatAmountArray, kFormatter } from '../../helpers/numberFormatter';

interface IInput {
	item: any;
}

interface IOutput {
	currentChart: any;
}

export default function useCurrentSnap({ item }: IInput): IOutput {
	const { responsePayload, defaultFields, fieldsToDisplay, fieldsConfig, grouping } = item || {};

	const chartsMap = useMemo(
		() => ({
			summary: {
				Component: Summary,
				adapter: () =>
					responsePayload[0]?.amount 
						? formatToCurrency(+responsePayload[0]?.amount) 
						: kFormatter(responsePayload[0]?.count, true) || 0,
				defaultFields: [],
				isTable: false,
				type: 'summary',
			},
			table: {
				Component: Table,
				adapter: () => formatAmountArray(responsePayload.itemsList),
				defaultFields: defaultFields?.length
					? defaultFields
					: [],
				fieldsConfig,
				fieldsToDisplay: fieldsToDisplay?.length
					? fieldsToDisplay
					: [],
				isTable: true,
				type: 'table',
			},
			column: {
				Component: Bars,
				adapter: () => formatAmountArray(responsePayload),
				defaultFields: [],
				isTable: false,
				type: 'column',
			},
			line: {
				Component: Diagram,
				adapter: () => formatAmountArray(responsePayload),
				defaultFields: [],
				isTable: false,
				type: 'line',
			},
			pie: {
				Component: PieChart,
				adapter: () => formatAmountArray(responsePayload),
				defaultFields: [],
				isTable: false,
				type: 'pie',
				grouping,
			},
			stackBar: {
				Component: StackBars,
				adapter: () => formatAmountArray(responsePayload),
				defaultFields: [],
				isTable: false,
				type: 'column',
				grouping,
			},
		}),
		// eslint-disable-next-line
		[item]
	);

	const currentChart = useMemo(
		() =>
			item?.isStackedBar
				? chartsMap['stackBar']
				: chartsMap[item?.chartType as keyof typeof chartsMap],
		// eslint-disable-next-line
		[item]
	);

	return {
		currentChart,
	};
}
